import React, { useEffect, useState } from "react"
import images from "../../../themes/images"
import ImageUploadComponent from "../adminModals/ServiziModal/ImageUploadComponent"
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  message,
  Modal,
  Row,
  Switch,
  Tabs,
  Tooltip,
  Upload,
} from "antd"
import { baseUrlImg } from "../../../config/api"
import { connect } from "react-redux"
import { MainActions, AuthActions } from "redux-store/models"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"
import "./EditServiceForm.css"
import { useHistory } from "react-router-dom"
import BonusModal from "../adminModals/ServiziModal/BonusModal"
import AddVariableServiceForm from "./AddVariableService"
import moment from "moment"
import * as XLSX from "xlsx"

const allowedTypes = ["exalogic", "Payment System", "betflag"]

const EditService = ({
  id,
  listino,
  selectedCompany,
  updateCompany,
  getSelectedCompany,
  UpdateServicesChangeStatus,
  activeSkinId,
  accountInfo,
  singleServiceChangeStatus,
  deleteOneService,
  createOneService,
  updateAdyenAllow,
  createInventoryVoucher,
}) => {
  const [logo, setLogo] = useState(null)
  const [logoScontrino, setLogoScontrino] = useState(null)
  const [icon, setIcon] = useState(null)
  const [bgImage, setBgImage] = useState(null)
  const [selectedService, setSelectedService] = useState("default")
  const [selectedServiceId, setSelectedServiceId] = useState("default")
  const [formData, setFormData] = useState({
    default: {
      servizio: "",
      commissioni: "",
      provigione: "",
      iva: "",
    },
  })
  const [openBonusModal, setOpenBonusModal] = useState(false)
  const [addServiceModal, setAddServiceModal] = useState(false)
  const [serviceChanges, setServiceChanges] = useState({})
  const [defaultChanges, setDefaultChanges] = useState({})
  const [content, setContent] = useState("")
  const [scontrinoContent, setScontrinoContent] = useState("")
  const [colorBg, setColorBg] = useState("")
  const [colorTesto, setColorTesto] = useState("")
  const [firstService, setFirstService] = useState()
  const [isEuro, setIsEuro] = useState(false)
  const [servicesAsCompany, setServicesAsCompany] = useState()
  const [loading, setLoading] = useState(false)
  const [editingService, setEditingService] = useState(null)
  const [serviceName, setServiceName] = useState("")
  const [newCost, setNewCost] = useState("")

  const [inventoryModalVisible, setInventoryModalVisible] = useState(false)
  const [inventoryFile, setInventoryFile] = useState(null)
  const [inventoryService, setInventoryService] = useState(null)

  const history = useHistory()
  let parsedNotes = {}

  if (selectedCompany && selectedCompany.company && selectedCompany.company.notes) {
    try {
      const rawNotes = JSON.parse(selectedCompany.company.notes)

      parsedNotes = Object.entries(rawNotes).reduce(function (acc, [key, value]) {
        if (!isNaN(Number(key)) && typeof value === "object") {
          Object.assign(acc, value)
        } else {
          acc[key] = value
        }
        return acc
      }, {})
    } catch (e) {
      console.error("Failed to parse notes:", e)
      parsedNotes = {}
    }
  }

  const showAddServiceIcon =
    selectedCompany &&
    selectedCompany?.services?.some(
      (service) =>
        allowedTypes.includes(service.type) || parseInt(service.cost, 10) === 0,
    )

  const isAdyen = selectedCompany?.company?.provider_name === "Adyen"

  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ align: [] }],
        ["link", "image", "video"],
      ],
    },
  }

  useEffect(() => {
    if (!selectedCompany || Object.keys(selectedCompany).length === 0) {
      getSelectedCompany(id, listino)
    }
  }, [id])

  useEffect(() => {
    if (
      selectedCompany &&
      selectedCompany.services &&
      selectedCompany.services.length > 0
    ) {
      const firstService = selectedCompany.services[0]
      setFirstService(firstService)
    }
  }, [selectedCompany])

  useEffect(() => {
    if (
      selectedCompany &&
      selectedCompany.services &&
      selectedCompany.services.length > 0
    ) {
      setServicesAsCompany(selectedCompany.company.services_as_company)
      const firstService = selectedCompany.services[0]
      setFirstService(firstService)

      const initialFormData = {}

      selectedCompany.services.forEach((service) => {
        initialFormData[service.service_id] = {
          servizio: service.cost || "",
          commissioni: service.commissione || "",
          provigione: service.provigione
            ? parseFloat(service.provigione.replace("$", "").trim()).toFixed(2)
            : "",
          iva: service.iva || "",
          system_aggio: service.system_aggio || "",
        }
      })

      initialFormData["default"] = {
        servizio: firstService.cost || "",
        commissioni: firstService.commissione || "",
        provigione: firstService.provigione
          ? parseFloat(firstService.provigione.replace("$", "").trim()).toFixed(2)
          : "",
        iva: firstService.iva || "",
        system_aggio: firstService.system_aggio || "",
      }

      setFormData(initialFormData)

      // Set isEuro based on the first service provigione
      setIsEuro(firstService.provigione?.includes("$") ?? false)

      if (firstService) {
        setLogo(firstService.logo)
        setBgImage(firstService.background)
        setIcon(firstService.icon)
        setLogoScontrino(firstService.scontrino)
        setColorBg(firstService.colorBg)
        setColorTesto(firstService.colorTesto)
        setContent(firstService.content)
        setScontrinoContent(firstService.content_scontrino)
      }
    }
  }, [selectedCompany])

  const handleChangeService = (value) => {
    setSelectedService(value)
    value === "default"
      ? setSelectedServiceId("default")
      : setSelectedServiceId(selectedCompany?.services[value]?.service_id)
  }

  const handleSubmit = async () => {
    let servicesToSend
    if (Object.keys(defaultChanges).length > 0 && selectedService === "default") {
      servicesToSend = defaultChanges
    } else {
      servicesToSend = serviceChanges
    }

    try {
      await updateCompany(
        id,
        logo?.id,
        bgImage?.id,
        icon?.id,
        logoScontrino?.id,
        colorBg,
        colorTesto,
        servicesToSend,
        content,
        scontrinoContent,
        !isEuro,
        servicesAsCompany,
        setLoading,
        listino,
      )
      setTimeout(() => {
        getSelectedCompany(id, listino)
      }, 1000)
    } catch (error) {
      console.error(error)
    } finally {
      setDefaultChanges({})
      setServiceChanges({})
    }
  }

  const handleFieldChange = (serviceId, field, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceId]: {
        ...prevFormData[serviceId],
        [field]: value,
      },
    }))
    if (serviceId === "default") {
      setDefaultChanges((prevDefaultChanges) => ({
        ...prevDefaultChanges,
        default: {
          ...prevDefaultChanges.default,
          [field]: value,
        },
      }))
    } else {
      setServiceChanges((prevChanges) => {
        const updatedChanges = { ...prevChanges }
        if (!updatedChanges[serviceId]) {
          updatedChanges[serviceId] = {}
        }
        updatedChanges[serviceId][field] = value
        return updatedChanges
      })
    }
  }
  const handleQuillChange = (value, isScontrino) => {
    isScontrino ? setScontrinoContent(value) : setContent(value)
  }

  const handleImageSelect = (selectedImage, imageType) => {
    const setters = {
      logo: setLogo,
      icon: setIcon,
      logoScontrino: setLogoScontrino,
      bgImage: setBgImage,
    }

    const setter = setters[imageType]
    if (setter) {
      setter(selectedImage)
    }
  }

  const handleStatusChange = (newStatus) => {
    UpdateServicesChangeStatus(
      selectedCompany?.company?.name,
      selectedCompany?.company?.full_name,
      id,
      newStatus,
      activeSkinId,
      async () => {
        getSelectedCompany(id, listino)
      },
      null,
      false,
    )
  }

  const handleSingleServiceStatusChange = (serviceId, newStatus) => {
    singleServiceChangeStatus(serviceId, newStatus, async () => {
      getSelectedCompany(id, listino)
    })
  }

  const shouldShowDeleteIcon = (singleService) => {
    const hasCostZero = selectedCompany?.services?.some(
      (service) => parseInt(service.cost) === 0,
    )

    return hasCostZero || allowedTypes.includes(singleService.type)
  }

  const handleDelete = (service_id) => {
    deleteOneService(service_id, async () => {
      getSelectedCompany(id, listino)
    })
  }

  return (
    <>
      <BonusModal
        open={openBonusModal}
        onClose={() => {
          setOpenBonusModal(false)
        }}
        selectedCompany={selectedCompany}
      />
      <AddVariableServiceForm
        isVisible={addServiceModal}
        onClose={() => setAddServiceModal(false)}
        id={id}
        getSelectedCompany={getSelectedCompany}
        accountInfo={accountInfo}
        createOneService={createOneService}
      />
      <div className="edit-service">
        <div className="service-header">
          <div className="service-left">
            <div className="service-logo" onClick={() => history.goBack()}>
              <i className="fal fa-chevron-left mr-1" />
              <img src={`${baseUrlImg}/${firstService?.icon}`} alt="service" />
            </div>
            <span className="service-name">
              {selectedCompany?.company?.full_name ?? selectedCompany?.company?.name}
            </span>
          </div>
          <div className="service-right">
            <div className="service-actions">
              <Switch
                style={{ width: 30, marginRight: 5 }}
                size="small"
                checked={selectedCompany?.company?.active === 1}
                onClick={() =>
                  handleStatusChange(selectedCompany?.company?.active === 0)
                }
              />
              <img
                src={images["bonusBtn"]}
                className={`activate-btn ${
                  selectedCompany?.company?.active === 0 ? "inactive" : ""
                }`}
                onClick={() => {
                  if (selectedCompany?.company?.active !== 0) {
                    setOpenBonusModal(true)
                  }
                }}
                alt="Bonus Button"
              />
            </div>
            <div className="service-checkbox">
              <Checkbox
                checked={servicesAsCompany === 1}
                onChange={(e) => setServicesAsCompany(e.target.checked ? 1 : 0)}
              >
                Services as company
              </Checkbox>
            </div>
          </div>
        </div>

        <div className="service-media">
          <div className="section-title">Media e colori</div>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={6} xl={4}>
              <ImageUploadComponent
                label="Logo"
                imageType="logo"
                value={logo}
                onImageSelect={(e) => handleImageSelect(e, "logo")}
                firstService={firstService}
              />
            </Col>
            <Col xs={24} sm={12} md={6} xl={4}>
              <ImageUploadComponent
                label="Icon"
                imageType="icon"
                value={icon}
                onImageSelect={(e) => handleImageSelect(e, "icon")}
                firstService={firstService}
              />
            </Col>
            <Col xs={24} sm={12} md={6} xl={4}>
              <ImageUploadComponent
                label="Logo scontrino"
                value={logoScontrino}
                imageType="scontrino"
                onImageSelect={(e) => handleImageSelect(e, "logoScontrino")}
                firstService={firstService}
              />
            </Col>
            <Col xs={24} sm={12} md={6} xl={4}>
              <ImageUploadComponent
                label="Background"
                value={bgImage}
                imageType="background"
                onImageSelect={(e) => handleImageSelect(e, "bgImage")}
                firstService={firstService}
              />
            </Col>
            <Col xs={24} sm={12} md={6} xl={4}>
              <Form.Item name="colorBg" label="Colore background">
                <Input
                  value={colorBg}
                  className="color-input"
                  onChange={(e) => setColorBg(e.target.value)}
                  prefix={
                    <input
                      type="color"
                      onChange={(e) => setColorBg(e.target.value)}
                      value={colorBg}
                      style={{ width: 30, height: 30 }}
                    />
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={4}>
              <Form.Item name="colorTesto" label="Colore Testo">
                <Input
                  value={colorTesto}
                  className="color-input"
                  onChange={(e) => setColorTesto(e.target.value)}
                  prefix={
                    <input
                      type="color"
                      onChange={(e) => setColorTesto(e.target.value)}
                      value={colorTesto}
                      style={{ width: 30, height: 30 }}
                    />
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <div className="service-variables">
          {/* {!isAdyen && (
            <>
              <div className="section-title">Servizi e variabili</div>
              <Form.Item name="selectedService">
                <div className="services-row">
                  <Row
                    gutter={16}
                    style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      width: "100%",
                    }}
                  >
                    {selectedCompany?.services
                      ?.sort((a, b) => a.cost - b.cost)
                      .map((service, index) => (
                        <Tooltip title={service.name}>
                          <Col
                            xs={8}
                            sm={8}
                            md={4}
                            xl={3}
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              paddingRight: "0px",
                            }}
                            className="service-col"
                          >
                            {shouldShowDeleteIcon(service) && (
                              <Icon
                                type="close"
                                className="delete-icon"
                                onClick={() => handleDelete(service.service_id)}
                              />
                            )}

                            <Card
                              onClick={() => handleChangeService(index)}
                              style={{
                                cursor: "pointer",
                                backgroundColor:
                                  selectedService === index
                                    ? "var(--accent-bg)"
                                    : "#fff",
                                width: "100%",
                                height: "66px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "4px",
                                padding: "0 10px",
                              }}
                            >
                              {selectedCompany.company.services_as_company ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: "100%",
                                  }}
                                >
                                  <Checkbox
                                    checked={service.active === 1}
                                    onChange={(e) => {
                                      handleSingleServiceStatusChange(
                                        service.id,
                                        e.target.checked ? 1 : 0
                                      )
                                    }}
                                  ></Checkbox>
                                  <div
                                    className="service-sign"
                                    style={{ marginLeft: 5 }}
                                  >
                                    {service.name}
                                  </div>
                                </div>
                              ) : parseFloat(service.cost) === 0 ? (
                                <div
                                  className="service-sign"
                                  style={{ fontSize: 14 }}
                                >
                                  {service.service_id === "ACM000"
                                    ? "Attivazione MasterCard"
                                    : "Variabile"}
                                </div>
                              ) : (
                                <>
                                  <div className="service-cost">{service.cost}</div>
                                  <div className="service-sign">Euro</div>
                                  {service.ean && (
                                    <div style={{ fontSize: "12px" }}>
                                     {service?.ean}
                                    </div>
                                  )}
                                </>
                              )}
                            </Card>
                          </Col>
                        </Tooltip>
                      ))}

                    <Col
                      xs={8}
                      sm={8}
                      md={4}
                      xl={3}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        paddingRight: "0px",
                      }}
                    >
                      <Card
                        onClick={() => handleChangeService("default")}
                        style={{
                          cursor: "pointer",
                          backgroundColor:
                            selectedService === "default"
                              ? "var(--accent-bg)"
                              : "#fff",
                          width: "100%",
                          height: "66px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className="service-cost"
                          style={{ marginTop: 0, fontWeight: 500, fontSize: 18 }}
                        >
                          Tutti
                        </div>
                      </Card>
                    </Col>
                    {showAddServiceIcon && (
                      <Col
                        xs={8}
                        sm={8}
                        md={3}
                        xl={2}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          paddingRight: "0px",
                        }}
                      >
                        <Card
                          onClick={() => setAddServiceModal(true)}
                          style={{
                            cursor: "pointer",
                            backgroundColor: "#fff",
                            width: "100%",
                            height: "66px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div
                            className="service-cost"
                            style={{
                              marginTop: 0,
                              fontSize: 30,
                              fontWeight: "lighter",
                            }}
                          >
                            +
                          </div>
                        </Card>
                      </Col>
                    )}
                  </Row>
                </div>
              </Form.Item>
            </>
          )} */}

          {!isAdyen && (
            <>
              <div className="section-title">Servizi e variabili</div>
              <Form.Item name="selectedService">
                <div className="services-row">
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      width: "100%",
                      gap: "8px",
                    }}
                  >
                    {selectedCompany?.services
                      ?.sort((a, b) => a.cost - b.cost)
                      .map((service, index) => (
                        <Tooltip title={service.name} key={index}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              flex: "0 0 120px",
                              position: "relative",
                            }}
                            className="service-col"
                          >
                            {shouldShowDeleteIcon(service) && (
                              <Icon
                                type="close"
                                className="delete-icon"
                                onClick={() => handleDelete(service.service_id)}
                              />
                            )}

                            <Icon
                              type="edit"
                              className="edit-icon"
                              onClick={(e) => {
                                e.stopPropagation()
                                setEditingService(service)
                                setServiceName(service.name)
                                setNewCost(service.cost)
                              }}
                            />

                            <Card
                              onClick={() => handleChangeService(index)}
                              style={{
                                cursor: "pointer",
                                position: "relative",
                                backgroundColor:
                                  selectedService === index
                                    ? "var(--accent-bg)"
                                    : "#fff",
                                width: "140px",
                                height: "100px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "4px",
                                padding: "0 10px",
                                overflow: "hidden",
                              }}
                            >
                              {service.is_inventory === 1 && (
                                <div
                                  className="inventory-upload-button"
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setInventoryService(service)
                                    setInventoryFile(null)
                                    setInventoryModalVisible(true)
                                  }}
                                >
                                  <Tooltip title="Carica inventario">
                                    <div className="inventory-upload-icon">
                                      <Icon type="upload" />
                                    </div>
                                  </Tooltip>
                                </div>
                              )}

                              <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "8px 0",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: "100%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Checkbox
                                    checked={service.active === 1}
                                    onChange={(e) => {
                                      e.stopPropagation()

                                      handleSingleServiceStatusChange(
                                        service.id,
                                        e.target.checked ? 1 : 0,
                                      )
                                    }}
                                  />

                                  <div
                                    className="service-sign"
                                    style={{
                                      marginLeft: 5,
                                    }}
                                  >
                                    {service.active === 1 ? "Attivo" : "Non attivo"}
                                  </div>
                                </div>

                                {parseFloat(service.cost) < 1 ? (
                                  <>
                                    <div
                                      className="service-sign"
                                      style={{
                                        fontSize: 14,
                                        fontWeight: "bold",
                                        marginTop: 4,
                                        marginBottom: 4,
                                      }}
                                    >
                                      {service.service_id === "ACM000"
                                        ? "Attivazione MasterCard"
                                        : "Variabile"}
                                    </div>

                                    {service?.ean && (
                                      <div
                                        style={{
                                          fontSize: "11px",
                                        }}
                                      >
                                        EAN: {service.ean}
                                      </div>
                                    )}

                                    {service?.service_id && (
                                      <div
                                        style={{
                                          fontSize: "11px",
                                          maxWidth: "120px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                        title={`ID: ${service.service_id}`}
                                      >
                                        ID: {service.service_id}
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {selectedCompany.company.services_as_company ? (
                                      <div
                                        className="service-sign"
                                        style={{
                                          marginLeft: 5,
                                        }}
                                      >
                                        {service.name}
                                      </div>
                                    ) : (
                                      <>
                                        <div className="service-cost">
                                          {service.cost}
                                        </div>

                                        <div className="service-sign">Euro</div>
                                      </>
                                    )}

                                    {service?.ean && (
                                      <div
                                        style={{
                                          fontSize: "11px",
                                        }}
                                      >
                                        EAN: {service.ean}
                                      </div>
                                    )}

                                    {service?.service_id && (
                                      <div
                                        style={{
                                          fontSize: "11px",
                                          maxWidth: "120px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                        title={`ID: ${service.service_id}`}
                                      >
                                        ID: {service.service_id}
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </Card>

                            <div>
                              <Checkbox
                                checked={service.pay_with_adyen}
                                onClick={() => {
                                  Modal.confirm({
                                    title: "Conferma aggiornamento",
                                    content:
                                      "Sei sicuro di voler abilitare Adyen per questo servizio?",
                                    okText: "Sì, aggiorna",
                                    cancelText: "Annulla",
                                    onOk: async () => {
                                      await updateAdyenAllow(
                                        service.id,
                                        listino,
                                        true,
                                        service.service_id,
                                      )

                                      setTimeout(() => {
                                        getSelectedCompany(id, listino)
                                      }, 1000)
                                    },
                                  })
                                }}
                              >
                                Pay with Adyen
                              </Checkbox>
                            </div>
                          </div>
                        </Tooltip>
                      ))}

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: "0 0 140px",
                      }}
                    >
                      <Card
                        onClick={() => handleChangeService("default")}
                        style={{
                          cursor: "pointer",
                          backgroundColor:
                            selectedService === "default"
                              ? "var(--accent-bg)"
                              : "#fff",
                          width: "140px",
                          height: "100px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className="service-cost"
                          style={{ marginTop: 0, fontWeight: 500, fontSize: 18 }}
                        >
                          Tutti
                        </div>
                      </Card>
                    </div>

                    {showAddServiceIcon && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          flex: "0 0 140px",
                        }}
                      >
                        <Card
                          onClick={() => setAddServiceModal(true)}
                          style={{
                            cursor: "pointer",
                            backgroundColor: "#fff",
                            width: "140px",
                            height: "100px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div
                            className="service-cost"
                            style={{
                              marginTop: 0,
                              fontSize: 30,
                              fontWeight: "lighter",
                            }}
                          >
                            +
                          </div>
                        </Card>
                      </div>
                    )}
                  </div>
                </div>
              </Form.Item>
            </>
          )}

          <Row
            gutter={[16, 16]}
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            className="service-commissione"
          >
            <Col xs={24} sm={12} md={6} xl={4}>
              <Form.Item name="commissioni" label="Commissioni">
                <Input
                  value={formData[selectedServiceId]?.commissioni}
                  onChange={(e) =>
                    handleFieldChange(
                      selectedServiceId,
                      "commissioni",
                      e.target.value,
                    )
                  }
                  placeholder="Commissioni"
                  suffix={
                    <i
                      className={isEuro ? "far fa-euro-sign" : "far fa-percent"}
                      onClick={() => setIsEuro(!isEuro)}
                      style={{ cursor: "pointer" }}
                    ></i>
                  }
                />
              </Form.Item>
            </Col>

            {!isAdyen && (
              <>
                <Col xs={24} sm={12} md={6} xl={4}>
                  <Form.Item name="provvigioni" label="Provvigioni agenzia">
                    <Input
                      value={formData[selectedServiceId]?.provigione}
                      onChange={(e) => {
                        handleFieldChange(
                          selectedServiceId,
                          "provigione",
                          e.target.value,
                        )
                      }}
                      placeholder={`Provvigioni agenzia (${isEuro ? "€" : "%"})`}
                      suffix={
                        <i
                          className={isEuro ? "far fa-euro-sign" : "far fa-percent"}
                          onClick={() => setIsEuro(!isEuro)}
                          style={{ cursor: "pointer" }}
                        ></i>
                      }
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={6} xl={4}>
                  <Form.Item name="bonus" label="Bonus agenzia">
                    <Input
                      className="bonus-ag"
                      placeholder="Bonus agenzia"
                      suffix={
                        <i
                          className="far fa-cog"
                          onClick={() => setOpenBonusModal(true)}
                        />
                      }
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={6} xl={4}>
                  <Form.Item name="system_aggio" label="Aggio bruto">
                    <Input
                      placeholder="Aggio"
                      value={formData[selectedServiceId]?.system_aggio}
                      onChange={(e) =>
                        handleFieldChange(
                          selectedServiceId,
                          "system_aggio",
                          e.target.value,
                        )
                      }
                    />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>

          {!isAdyen && (
            <Row
              gutter={[16, 16]}
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
              className="service-commissione"
            >
              <Col xs={24} sm={12} md={6} xl={4}>
                <Form.Item name="iva" label="IVA" className="iva">
                  <Input
                    placeholder="IVA"
                    value={formData[selectedServiceId]?.iva}
                    onChange={(e) =>
                      handleFieldChange(selectedServiceId, "iva", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6} xl={4}>
                <Form.Item
                  name="descrizione"
                  label="Descrizione IVA"
                  className="descrizione"
                >
                  <Input
                    placeholder="Descrizione IVA"
                    value={formData[selectedServiceId]?.descrizione}
                    onChange={(e) =>
                      handleFieldChange(
                        selectedServiceId,
                        "descrizione",
                        e.target.value,
                      )
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6} xl={4}>
                <Form.Item
                  name="data_inizio"
                  label="Data inizio"
                  className="data-inizio"
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    placeholder="Immediato"
                    format="DD/MM/YYYY"
                    value={
                      formData[selectedServiceId]?.data_inizio
                        ? moment(formData[selectedServiceId].data_inizio)
                        : null
                    }
                    disabledDate={(current) =>
                      current && current.isSameOrBefore(moment(), "day")
                    }
                    onChange={(date) =>
                      handleFieldChange(
                        selectedServiceId,
                        "data_inizio",
                        date ? date.format("YYYY-MM-DD") : null,
                      )
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
        </div>
        <div className="service-information">
          <Row>
            <Col xs={24} sm={24} md={12} lg={12}>
              <div className="section-title">Informazioni</div>
              <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="Guida all’uso" key="1">
                  <ReactQuill
                    value={content}
                    onChange={(e) => handleQuillChange(e, false)}
                    modules={modules}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Informazioni scontrino" key="2">
                  <ReactQuill
                    value={scontrinoContent}
                    onChange={(e) => handleQuillChange(e, true)}
                    modules={modules}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Storico prezzi" key="3">
                  {parsedNotes &&
                    (() => {
                      const updates = Object.entries(
                        Object.entries(parsedNotes)
                          .flatMap(([code, history]) =>
                            Object.entries(history)
                              .filter(
                                ([_, details]) => details.listino_id == listino,
                              )
                              .map(([timestamp, details]) => ({
                                timestamp,
                                code,
                                details,
                              })),
                          )
                          .reduce((acc, { timestamp, code, details }) => {
                            if (!acc[timestamp]) acc[timestamp] = []
                            acc[timestamp].push({ code, details })
                            return acc
                          }, {}),
                      ).sort(
                        ([a, _a], [b, _b]) =>
                          new Date(b).getTime() - new Date(a).getTime(),
                      )

                      return (
                        <div className="notes-container">
                          {updates.map(([timestamp, services]) => (
                            <div key={timestamp} className="timestamp-group">
                              <div className="last-modified font-bold mb-2">
                                Ultima modifica:{" "}
                                {moment(timestamp).format("DD/MM/YYYY, HH:mm:ss")}
                              </div>

                              {services.map(({ code, details }) => (
                                <div key={code} className="note-entry mb-2">
                                  <div className="note-code font-semibold">
                                    {code}
                                  </div>
                                  <div className="modified-fields">
                                    (
                                    {[
                                      "commissione",
                                      "system_aggio",
                                      "agency_guadagno",
                                    ]
                                      .filter((key) => details[key])
                                      .map((key, index, arr) => {
                                        const value = details[key]
                                        const formattedKey = key
                                          .replace(/_/g, " ")
                                          .replace(/\b\w/g, (char) =>
                                            char.toUpperCase(),
                                          )

                                        return (
                                          <span
                                            key={key}
                                            className="light-field text-gray-500"
                                          >
                                            {formattedKey}: {value}
                                            {index !== arr.length - 1 ? ", " : " "}
                                          </span>
                                        )
                                      })}
                                    )
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      )
                    })()}
                </Tabs.TabPane>
              </Tabs>
            </Col>
          </Row>
        </div>

        <Row
          gutter={[16, 16]}
          style={{
            display: "flex",
            flexWrap: "wrap",
            marginBottom: 20,
          }}
          className="form-buttons"
        >
          <Col xs={12} sm={12} md={6} xl={4}>
            <Button block type="default" onClick={() => history.goBack()}>
              CANCELLA
            </Button>
          </Col>

          <Col xs={12} sm={12} md={6} xl={4}>
            <Button block type="primary" onClick={handleSubmit} loading={loading}>
              SALVA
            </Button>
          </Col>
        </Row>
        <Modal
          title="Modifica il servizio"
          visible={!!editingService}
          onCancel={() => setEditingService(null)}
          onOk={async () => {
            singleServiceChangeStatus(
              editingService.id,
              editingService.status,
              async () => {
                setEditingService(null)
                getSelectedCompany(id, listino)
              },
              serviceName,
              newCost,
            )
          }}
        >
          <Input
            value={serviceName}
            onChange={(e) => setServiceName(e.target.value)}
            placeholder="Service name"
          />
          <Input
            style={{ marginTop: 10 }}
            value={newCost}
            onChange={(e) => setNewCost(e.target.value)}
            placeholder="Service cost"
          />
        </Modal>

        <Modal
          title="Carica CSV inventario"
          visible={inventoryModalVisible}
          onCancel={() => {
            setInventoryModalVisible(false)
            setInventoryFile(null)
            setInventoryService(null)
          }}
          width={500}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                setInventoryModalVisible(false)
                setInventoryFile(null)
                setInventoryService(null)
              }}
            >
              Annulla
            </Button>,
            <Button
              key="submit"
              type="primary"
              disabled={!inventoryFile}
              onClick={async () => {
                if (!inventoryFile || !inventoryService) {
                  return
                }

                try {
                  const arrayBuffer = await inventoryFile.arrayBuffer()

                  const workbook = XLSX.read(arrayBuffer, {
                    type: "array",
                    cellDates: true,
                  })

                  const firstSheetName = workbook.SheetNames[0]
                  const worksheet = workbook.Sheets[firstSheetName]

                  const rawVoucher = XLSX.utils.sheet_to_json(worksheet, {
                    defval: null,
                  })

                  const formatDate = (date) => {
                    const pad = (value) => String(value).padStart(2, "0")

                    return `${pad(date.getDate())}/${pad(
                      date.getMonth() + 1,
                    )}/${date.getFullYear()} ${pad(
                      date.getHours(),
                    )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
                  }

                  const voucher = rawVoucher.map((row) =>
                    Object.fromEntries(
                      Object.entries(row).map(([key, value]) => [
                        key,
                        value instanceof Date ? formatDate(value) : value,
                      ]),
                    ),
                  )

                  console.log("Inventory JSON:", voucher)
                  console.log("Service:", inventoryService)

                  createInventoryVoucher(inventoryService.service_id, voucher)

                  setInventoryModalVisible(false)
                  setInventoryFile(null)
                  setInventoryService(null)
                } catch (error) {
                  console.error("Error converting inventory file:", error)

                  message.error("Errore durante la lettura del file.")
                }
              }}
            >
              Carica inventario
            </Button>,
          ]}
        >
          <div style={{ marginBottom: 20 }}>
            <p style={{ marginBottom: 8 }}>
              Seleziona il file contenente i dati dell'inventario.
            </p>

            <p
              style={{
                fontSize: 13,
                color: "#666",
                marginBottom: 16,
              }}
            >
              Formati consentiti: <strong>CSV, XLS, XLSX</strong>. Il file verrà
              elaborato e associato al servizio selezionato.
            </p>

            <Upload
              accept=".csv,.xlsx,.xls"
              showUploadList={true}
              beforeUpload={(file) => {
                const fileName = file.name.toLowerCase()

                const isValidFile =
                  file.type === "text/csv" ||
                  fileName.endsWith(".csv") ||
                  fileName.endsWith(".xlsx") ||
                  fileName.endsWith(".xls")

                if (!isValidFile) {
                  message.error("Per favore seleziona un file CSV o Excel.")

                  return Upload.LIST_IGNORE
                }

                setInventoryFile(file)

                return false
              }}
              onRemove={() => {
                setInventoryFile(null)
              }}
              fileList={inventoryFile ? [inventoryFile] : []}
            >
              <Button>
                <Icon type="upload" />
                Seleziona file
              </Button>
            </Upload>
          </div>
        </Modal>
      </div>
    </>
  )
}

const EditServiceForm = Form.create()(EditService)

const mapStateToProps = (state) => ({
  selectedCompany: state.main.selectedCompany,
  activeSkinId: state.main.activeSkinId,
  accountInfo: state.auth.accountInfo,
})

export default connect(mapStateToProps, { ...AuthActions, ...MainActions })(
  EditServiceForm,
)
